import { Snackbar } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import PhoneFrame from '../components/PhoneFrame';
import StudentDesktopPronunciationPage from '../../studentDesktop/page/StudentDesktopPronunciationPage';

export default function StudentPronunciation() {
    const history = useHistory();
    const [notice, setNotice] = React.useState('');
    return <PhoneFrame title="Pronunciation" onBack={() => history.push('/mockup/v2/student')}>
        <StudentDesktopPronunciationPage embedded onNotice={setNotice} />
        <Snackbar open={Boolean(notice)} message={notice} autoHideDuration={4000} onClose={() => setNotice('')} />
    </PhoneFrame>;
}
